/**
 * Binance timeframe configuration and interval mapping.
 * @see https://developers.binance.com/docs/binance-spot-api-docs/rest-api/market-data-endpoints#klinecandlestick-data
 */

import {
  registerExchangeTimeframes,
  resolutionToSeconds,
  type TimeframeConfig,
} from '../../lib/timeframes';

/**
 * Binance supports 1-second candles natively.
 */
export const BINANCE_TIMEFRAMES: TimeframeConfig = {
  native: [
    '1s',
    '1m',
    '3m',
    '5m',
    '15m',
    '30m',
    '1h',
    '2h',
    '4h',
    '6h',
    '8h',
    '12h',
    '1d',
    '3d',
    '1w',
    '1M',
  ],
  synthetic: [],
  minIntervalSeconds: 1,
};

// Register with central registry
registerExchangeTimeframes('binance', BINANCE_TIMEFRAMES);

/**
 * Maps TradingView resolution to Binance interval format.
 */
export const mapToBinanceInterval = (resolution: string): string => {
  const seconds = resolutionToSeconds(resolution);

  if (seconds === 1) return '1s';
  if (seconds === 60) return '1m';
  if (seconds === 180) return '3m';
  if (seconds === 300) return '5m';
  if (seconds === 900) return '15m';
  if (seconds === 1800) return '30m';
  if (seconds === 3600) return '1h';
  if (seconds === 7200) return '2h';
  if (seconds === 14400) return '4h';
  if (seconds === 21600) return '6h';
  if (seconds === 28800) return '8h';
  if (seconds === 43200) return '12h';
  if (seconds === 86400) return '1d';
  if (seconds === 259200) return '3d';
  if (seconds === 604800) return '1w';
  if (seconds === 2592000) return '1M';

  // Default to closest
  if (seconds < 60) return '1m';
  if (seconds < 180) return '1m';
  return '1h';
};
